import {FormattedMessage, useIntl, defineMessages} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';

import styles from './group-load-warning.css';

const messages = defineMessages({
    title: {
        defaultMessage: 'Replace the group project?',
        description: 'Title of the dialog warning that loading a file replaces a group project',
        id: 'gui.groupLoadWarning.title'
    }
});

const GroupLoadWarning = props => {
    const intl = useIntl();
    return (
        <Modal
            className={styles.modalContent}
            contentLabel={intl.formatMessage(messages.title)}
            id="groupLoadWarning"
            onRequestClose={props.onCancel}
        >
            <Box className={styles.body}>
                <Box className={styles.text}>
                    <FormattedMessage
                        defaultMessage="Loading a file replaces the project for everyone in your group, not just you. Everyone's current work will be lost."
                        description="Body of the dialog warning that loading a file replaces a group project"
                        id="gui.groupLoadWarning.body"
                    />
                </Box>
                <Box className={styles.buttonRow}>
                    <button onClick={props.onCancel}>
                        <FormattedMessage
                            defaultMessage="Cancel"
                            description="Button to cancel loading a file into a group project"
                            id="gui.groupLoadWarning.cancel"
                        />
                    </button>
                    <button
                        className={styles.okButton}
                        onClick={props.onContinue}
                    >
                        <FormattedMessage
                            defaultMessage="Choose a file"
                            description="Button to continue to the file picker when loading into a group project"
                            id="gui.groupLoadWarning.continue"
                        />
                    </button>
                </Box>
            </Box>
        </Modal>
    );
};

GroupLoadWarning.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired
};

export default GroupLoadWarning;
